import { z } from "zod";
import { documentoRelacionadoSchema, facturaBaseSchema, emisorBaseSchema } from "./common.schema";

export const itemCCFSchema = z
  .object({
    numItem: z.number().int().min(1),

    // 1 = Bien, 2 = Servicio
    tipoItem: z.union([z.literal(1), z.literal(2)]),

    descripcion: z.string().min(1, "La descripción es requerida"),

    // Puede llegar como string o número
    cantidad: z
      .union([z.string(), z.number()])
      .transform((val) => Number(val))
      .refine((val) => !isNaN(val) && val >= 0, {
        message: "Cantidad debe ser un número positivo",
      }),

    uniMedida: z.number().int(),

    precioUni: z
      .union([z.string(), z.number()])
      .transform((val) => Number(val))
      .refine((val) => !isNaN(val) && val >= 0, {
        message: "Precio unitario debe ser un número positivo",
      }),

    ventaNoSuj: z.number().nonnegative(),
    ventaExenta: z.number().nonnegative(),
    ventaGravada: z.number().nonnegative(),

    tributos: z.union([z.array(z.string()), z.null()]),

    // Opcionales y campos adicionales
    codTributo: z.union([z.string(), z.null()]).optional(),
    numeroDocumento: z.union([z.string(), z.null()]).optional(),
    montoDescu: z.number().nonnegative(),
    codigo: z.union([z.string(), z.null()]).optional(),
    psv: z.number().nonnegative(),
    noGravado: z.number().nonnegative(),
  })
  .strip();

export const resumenCCFSchema = z
  .object({
    totalNoSuj: z.number().default(0),
    totalExenta: z.number().default(0),
    totalGravada: z.number().default(0),
    subTotalVentas: z.number().default(0),
    descuNoSuj: z.number().default(0),
    descuExenta: z.number().default(0),
    descuGravada: z.number().default(0),
    porcentajeDescuento: z.number().default(0),
    totalDescu: z.number().default(0),
    tributos: z
      .array(
        z.object({
          codigo: z.string(),
          descripcion: z.string(),
          valor: z.number(),
        })
      )
      .default([]),
    subTotal: z.number().default(0),
    ivaPerci1: z.number().default(0),
    ivaRete1: z.number().default(0),
    reteRenta: z.number().default(0),
    montoTotalOperacion: z.number().default(0),
    totalNoGravado: z.number().default(0),
    totalPagar: z.number().default(0),
    totalLetras: z.string().default(""),
    condicionOperacion: z.number().default(1),
    saldoFavor: z.number().default(0),
    condicionOperacion: z.number().default(2), // 1 contado, 2 credito, 3 otros
    pagos: z
      .array(
        z.object({
          codigo: z.string(),
          montoPago: z.number(),
          referencia: z.string().nullable(),
          plazo: z.string().nullable(),
          periodo: z.number().nullable(),
        })
      )
      .nullable()
      .default(null),
    numPagoElectronico: z.string().default(""),
  })
  .strip();

export const facturaCCFSchema = facturaBaseSchema
  .extend({
    documentoRelacionado: documentoRelacionadoSchema.min(1).max(50).nullable(),
    resumen: resumenCCFSchema,
    otrosDocumentos: z.any().nullable(),
    emisor: emisorBaseSchema.strip(),
  })
  .strip();
